<template>
  <div class="dea-leg" :class="cardModifier">
    <div class="dea-leg__badge-container" :class="leg.event_bgMod"></div>
    <div class="dea-leg__wrapper" :class="{ 'dea-leg__wrapper--selected': selected }">
      <div class="dea-leg__heading">
        <h3 class="dea-heading--medium__ms">{{ leg.day }} {{ selected }}</h3>
      </div>
      <span v-if="leg.is_past_date" :class="leg.event_colorMod" class="dea-heading--medium__xs dea-leg__heading-warning"
        >evento già svolto</span
      >
      <h2 class="dea-heading--medium__ml dea-leg__info dea-leg__info--city" :class="leg.event_colorMod">
        {{ leg.highlight }}
      </h2>
      <div v-if="linkDetail && leg.hours" class="dea-heading--regular__xm dea-leg__info">{{ leg.hours }}</div>
      <div
        v-if="leg.place"
        class="dea-leg__info dea-leg__info--place"
        :class="{ 'dea-heading--regular__xm': selected, 'dea-heading--regular__xs': !selected }"
      >
        {{ leg.place }}
      </div>
      <Buttons
        v-if="linkDetail"
        :href="leg.get_absolute_url"
        type="a"
        class="dea-button dea-button--small dea-button--iconRight dea-leg__button"
        >{{ linkDetail }}</Buttons
      >
      <template v-for="(link, index) in leg.documents">
        <Buttons
          v-if="link && link.type === 'url'"
          :key="index"
          :href="link.url"
          type="a"
          class="dea-leg__button dea-button dea-button dea-button--small dea-button--full dea-text--right"
          >{{ link.title }}</Buttons
        >
        <Buttons
          v-if="link && link.type === 'download'"
          :key="index"
          :href="link.url"
          type="a"
          class="dea-button dea-button--outline dea-button--small dea-button--full dea-button--iconRight dea-text--right"
          icon="download"
          >{{ link.title }}</Buttons
        >
      </template>
    </div>
  </div>
</template>
<script>
import Buttons from "@/components/elements/Buttons";

export default {
  name: "CardLeg",

  components: { Buttons },
  props: {
    leg: {
      type: Object,
      default: () => {
        return {
          event_bgMod: "bg-event-seminar",
          event_colorMod: "dea-color-event-seminar",
          day: "18 Maggio 2019",
          is_past_date: true,
          highlight: "Montesarchio (BN)",
          hours: "ore 17.30 - 18.30",
          place: "Centro Congressi Giovanni XXIII Via Papa Giovanni XXIII, 106 - Bergamo",
          get_absolute_url: "/example/",
          documents: [
            {
              title: "Scarica il programma",
              url: "#",
              type: "download",
            },
            {
              title: "Vedi minisito",
              url: "#",
              type: "link",
            },
          ],
        };
      },
    },
    cardModifier: {
      type: String,
      default: "",
    },
    selected: {
      type: Boolean,
      default: true,
    },
    linkDetail: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

$badge-container-width: calc(100% - #{$space-x-small});
$badge-container-padding-bottom: calc(#{$space-x-small} + #{$space-xxx-small});

.dea-leg {
  &__wrapper {
    background-color: $dea-color-white;
    border-top-left-radius: $border-radius-large;
    border-top-right-radius: $border-radius-large;
    box-shadow: $box-shadow-medium-legs;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: $space-x-small;

    &--selected {
      border: $border-light $dea-color-grey-medium-light;
      box-shadow: none;
    }
  }

  &__badge-container {
    border-top-left-radius: $border-radius-large;
    border-top-right-radius: $border-radius-large;
    margin-bottom: -$space-x-small;
    margin-left: $space-xx-small;
    padding: $space-x-small $space-x-small $badge-container-padding-bottom;
    width: $badge-container-width;
  }

  &__heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: $space-x-small 0;

    > * {
      margin: 0;
    }

    &-warning {
      color: $dea-color-target-magenta-formazione;
    }
  }

  &__info {
    margin-bottom: $space-xx-small;

    &--city {
      flex-grow: 1;
      margin-top: $space-x-small;
      min-height: 2em;
    }

    &--place {
      flex-grow: 1;
    }
  }

  &__button {
    margin-left: auto;
  }

  .dea-button + .dea-button {
    margin-top: $space-x-small;
  }
}
</style>
